import { IDealStep, CONFIGURED, DEALER, FINANCE, ORDERED, MY_INFORMATION, PAYMENT } from './renderDealStapsFlow';
import { IMySavedDeal, MySavedDealJourneyType } from '../../../../redux/user/user.duck.interface';
import { PaymentStatuses } from '../../../../constants/paymentStatuses';
import { TranslateFunction } from '@hooks/useTranslations';
import { dealStatuses } from 'src/pages/checkout/pre-order';

export const createMySavesDealSteps = (t: TranslateFunction, mySavedDeal: IMySavedDeal): IDealStep[] => {
    const ret: IDealStep[] = [];
    ret.push({
        id: CONFIGURED,
        done: true,
        text: t('myaccount.dealSteps.configured'),
    });
    ret.push({
        id: DEALER,
        done: !!mySavedDeal.dealerId || mySavedDeal.fullProductConfiguration.dealers?.length > 0,
        text: t('myaccount.dealSteps.dealer'),
    });
    if (mySavedDeal.journeyType === MySavedDealJourneyType.BUY_ONLINE_CASH) {
        const hasCashPaymentProcessInProgress = [
            dealStatuses.cashPayment,
            dealStatuses.cashPaymentKo,
            dealStatuses.checkoutProforma,
        ].includes(mySavedDeal.status);
        ret.push({
            id: MY_INFORMATION,
            done: hasCashPaymentProcessInProgress || !!mySavedDeal.details,
            text: t('myaccount.dealSteps.myInformation'),
        });
        ret.push({
            id: PAYMENT,
            done: hasCashPaymentProcessInProgress ? false : undefined,
            text: t('myaccount.dealSteps.payment'),
        });
    } else if (mySavedDeal.journeyType === MySavedDealJourneyType.BUY_ONLINE_FINANCE) {
        ret.push({
            id: FINANCE,
            done: [
                PaymentStatuses.financeApproved,
                PaymentStatuses.redirected_to_loan_provider,
                PaymentStatuses.financeRejected,
            ].includes(mySavedDeal.status),
            text: t('myaccount.dealSteps.finance'),
        });
    }

    ret.push({
        id: ORDERED,
        done: undefined,
        text: t('myaccount.dealSteps.ordered'),
    });
    return ret;
};

export const createMyOrdersDealSteps = (t: TranslateFunction, pxUpload?: boolean): IDealStep[] => {
    const ret = [
        {
            id: 'orderConfirmed',
            done: true,
            text: t('myaccount.dealSteps.orderConfirmed'),
        },
    ];

    if (pxUpload !== undefined) {
        ret.push({
            id: DEALER,
            done: pxUpload,
            text: t('partExchange.status.title'),
        });
    }

    return ret;
};
